export const stateValuesDos = [
    {fullName:"Alabama",index:"AL"},
    {fullName:"Alaska",index:"AK"},
    {fullName:"Arizona",index:"AZ"},
    {fullName:"Arkansas",index:"AR"},
    {fullName:"American Samoa",index:"AS"},
    {fullName:"California",index:"CA"},
    {fullName:"Colorado",index:"CO"},
    {fullName:"Connecticut",index:"CT"},
    {fullName:"Delaware",index:"DE"},
    {fullName:"District of Columbia",index:"DC"},
    {fullName:"Florida",index:"FL"},
    {fullName:"Georgia",index:"GA"},
    {fullName:"Guam",index:"GU"},
    {fullName:"Hawaii",index:"HI"},
    {fullName:"Idaho",index:"ID"},
    {fullName:"Illinois",index:"IL"},
    {fullName:"Indiana",index:"IN"},
    {fullName:"Iowa",index:"IA"},
    {fullName:"Kansas",index:"KS"},
    {fullName:"Kentucky",index:"KY"},
    {fullName:"Louisiana",index:"LA"},
    {fullName:"Maine",index:"ME"},
    {fullName:"Maryland",index:"MD"},
    {fullName:"Massachusetts",index:"MA"},
    {fullName:"Michigan",index:"MI"},
    {fullName:"Minnesota",index:"MN"},
    {fullName:"Mississippi",index:"MS"},
    {fullName:"Missouri",index:"MO"},
    {fullName:"Montana",index:"MT"},
    {fullName:"Nebraska",index:"NE"},
    {fullName:"Nevada",index:"NV"},
    {fullName:"New Hampshire",index:"NH"},
    {fullName:"New Jersey",index:"NJ"},
    {fullName:"New Mexico",index:"NM"},
    {fullName:"New York",index:"NY"},
    {fullName:"North Carolina",index:"NC"},
    {fullName:"North Dakota",index:"ND"},
    {fullName:"Northern Mariana Islands",index:"MP"},
    {fullName:"Ohio",index:"OH"},
    {fullName:"Oklahoma",index:"OK"},
    {fullName:"Oregon",index:"OR"},
    {fullName:"Pennsylvania",index:"PA"},
    {fullName:"Puerto Rico",index:"PR"},
    {fullName:"Rhode Island",index:"RI"},
    {fullName:"South Carolina",index:"SC"},
    {fullName:"South Dakota",index:"SD"},
    {fullName:"Tennessee",index:"TN"},
    {fullName:"Texas",index:"TX"},
    {fullName:"Trust Territories",index:"TT"},
    {fullName:"Utah",index:"UT"},
    {fullName:"Vermont",index:"VT"},
    {fullName:"Virginia",index:"VA"},
    {fullName:"Virgin Islands",index:"VI"},
    {fullName:"Washington",index:"WA"},
    {fullName:"West Virginia",index:"WV"},
    {fullName:"Wisconsin",index:"WI"},
    {fullName:"Wyoming",index:"WY"}
]



export const fixUpperCaseandUnderscore = (word) =>{
    let newWordArray = word.split("_");

    // newWordArray.forEach(wrd=>{
    //     wrd = wrd.charAt(0).toUpperCase() + wrd.slice(1)
    // })

    for(var x=0; x<newWordArray.length; x++){
        newWordArray[x] = newWordArray[x].charAt(0).toUpperCase() + newWordArray[x].slice(1)
    };
    

    let newString = "";
    for(x=0; x<newWordArray.length; x++){
        if(x===0){
            newString = newWordArray[x];
        }else{
            newString = newString + " " + newWordArray[x];
        }
    };
    return newString;
}